import React from 'react';
import handleViewport from 'react-in-viewport';
import {Loader} from '../../../components/Loader/Loader';
class AnalyticsSimpleTile1 extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            collapsed: this.getIsCollapsedFlag(props)
        };
    }

    componentDidUpdate(prevProps) {
        const prevCollapsedState = this.getIsCollapsedFlag(prevProps);
        const curCollapsedState = this.getIsCollapsedFlag(this.props);
        if (prevCollapsedState !== curCollapsedState) {
            this.setState({ collapsed: curCollapsedState });
        }
    }

    getIsCollapsedFlag = (props) => {
        return (props.settings?.collapsedState || {})[props.sectionName];
    }

    render() {
        const { collapsed } = this.state;
        const { mode, inViewport, sectionName } = this.props;

        return <div className={`analytics-simple-tile ${collapsed && !mode ? 'collapsed' : ''}`}>
            <div className="analytics-simple-tile__header">
                <div className="analytics-simple-tile__cell" />
                <div className="analytics-simple-tile__cell">
                    {!mode && <i className="icon icon-alan-stat-compare-stats analytics-simple-tile__compare"
                        onClick={this.props.openCompare} />}
                    {!mode &&
                        <i className="icon icon-alan-stat-open analytics-simple-tile__open"
                            onClick={this.props.openInPopup} />}
                </div>
            </div>
            <div className="analytics-simple-tile__body">
                {(sectionName === 'patternFlows' || sectionName === 'locations') ?
                    this.props.children :
                    (inViewport ?
                        this.props.children :
                        <Loader theme="dark" size="small" center={true} />)}
            </div>
        </div>;
    }
}

export const AnalyticsSimpleTile = handleViewport(AnalyticsSimpleTile1);